import { createSlice } from '@reduxjs/toolkit';

const initialState = null;

const vehicleSlice = createSlice({
    name: 'vehicle',
    initialState,
    reducers: {
        setVehicle(state, action) {
            return action.payload;
        },
        removeVehicle(state) {
            return initialState;
        },
    },
});

export const { setVehicle, removeVehicle } = vehicleSlice.actions;
export default vehicleSlice.reducer;